import { mapGetters, mapMutations, mapActions } from 'vuex'
export default {
	data: () => ({
		rules: {
			required: (value) => !!value || "Обов'язкове для заповнення",
			onlyFromList: (v) => (!!v && v?.id > 0 ) || "Необхідно обрати значення зі списку",
		},
	}),

	computed: {
		...mapGetters('VehicleParam', { item: 'params' }),
	},

	methods: {
		reset() {
			this.$refs.form.reset()
		},

		validate() {
			return this.$refs.form.validate()
		},
	},
}